import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskPrivateNoteChanged } from 'api/notifications/meta';
import { Causer } from './causer';

export const TaskPrivateNoteChangedView: FC<{
  meta: TaskPrivateNoteChanged;
  isTaskWithFormInstance: boolean;
}> = ({ meta: { by }, isTaskWithFormInstance }) => (
  <FormattedMessage
    id={
      isTaskWithFormInstance
        ? 'notifications.messages.form_task_private_note_changed'
        : 'notifications.messages.task_private_note_changed'
    }
    values={{
      causer: <Causer user={by} />,
    }}
  />
);
